import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-50"
}
const _hoisted_2 = { class: "flex flex-col flex-grow h-full mx-10 mt-6" }
const _hoisted_3 = { class: "text-left text-lg mx-8" }
const _hoisted_4 = { class: "font-semibold" }

import LbrxNumPad from "@/components/LbrxNumPad.vue";

import {
  defineComponent,
  defineProps,
  defineEmits,
  onMounted,
  watch,
  reactive,
} from "vue";

const __default__ = defineComponent({
  name: "LbrxPrdQuantity",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    active: { type: Boolean },
    selectedItem: {}
  },
  emits: ["closeQuantityPopup", "confirmPrdQty"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const state = reactive({
  quantity: "",
});

const closePopup=()=> {
    emit("closeQuantityPopup")
}

const handleClickPropagation = () => {
  event?.stopPropagation();
};

const addAmount = (item: any) => {
  if (item === -1) {
    state.quantity = "";
  } else if (item === -2) {
    state.quantity = "";
  } else {
    state.quantity += item;
  }
};

const confirmQty=()=> {
    emit("confirmPrdQty", state.quantity)
    state.quantity = "";
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.active)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 flex justify-center items-center z-50 blur-none my-16",
          onClick: closePopup
        }, [
          _createElementVNode("div", {
            class: "bg-[#fff] w-[670px] my-52 rounded-3xl overflow-hidden h-full flex flex-col border-2 border-b-gray-300 absolute",
            onClick: handleClickPropagation
          }, [
            _createElementVNode("span", {
              class: "absolute right-6 top-2 scale-[240%]",
              onClick: closePopup
            }, "×"),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("Pos.Product") + ": "), 1),
                _createTextVNode(_toDisplayString(_ctx.selectedItem.name), 1)
              ]),
              _createVNode(LbrxNumPad, {
                amountToGive: state.quantity,
                onAddAmount: addAmount,
                cashierMode: true,
                onConfirmAction: confirmQty
              }, null, 8, ["amountToGive"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})